import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { CreateConfiguration } from '@principle-theorem/ng-principle-shared';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import { MultiTreatmentConfiguration } from '@principle-theorem/principle-core';
import { type IMultiTreatmentConfiguration } from '@principle-theorem/principle-core/interfaces';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface IMultiTreatmentFormData
  extends Pick<IMultiTreatmentConfiguration, 'name'> {}

@Component({
  selector: 'pr-create-multi-treatment-configuration',
  templateUrl: './create-multi-treatment-configuration.component.html',
  styleUrls: ['./create-multi-treatment-configuration.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CreateMultiTreatmentConfigurationComponent extends CreateConfiguration<
  CreateMultiTreatmentConfigurationComponent,
  IMultiTreatmentFormData,
  IMultiTreatmentConfiguration
> {
  form: TypedFormGroup<IMultiTreatmentFormData> =
    new TypedFormGroup<IMultiTreatmentFormData>({
      name: new TypedFormControl('', Validators.required),
    });

  protected _transformData(
    formData: IMultiTreatmentFormData
  ): IMultiTreatmentConfiguration {
    return MultiTreatmentConfiguration.init(formData);
  }
}
